import ProfileLayout from "./layout";

const PaymentGatewayForm = () => {
  return (
    <ProfileLayout>
      <form>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Payment Gateway</h2>
            <p className="ms-2 card-subtitle text-muted">
              Please enter your payment gateway details below.
            </p>
          </div>
          <div className="card-body">
            <div className="mb-3">
              <label htmlFor="api_key" className="form-label">
                API Key
              </label>
              <input
                type="text"
                className="form-control"
                id="api_key"
                placeholder="Enter your API key"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="private_key" className="form-label">
                Private Key
              </label>
              <input
                type="text"
                className="form-control"
                id="private_key"
                placeholder="Enter your private key"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="merchant_code" className="form-label">
                Merchant Code
              </label>
              <input
                type="text"
                className="form-control"
                id="merchant_code"
                placeholder="Enter your merchant code"
              />
            </div>
          </div>
          <div className="card-footer text-end">
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </div>
      </form>
    </ProfileLayout>
  );
};

export default PaymentGatewayForm;
